module.exports = __webpack_public_path__ + "static/thermostat-2b7f6972e844a92f119567b0698308c3.png";